export default "__VITE_ASSET__2e3de840__"